import React from 'react';


const Footer = () => {
    return (
        <footer className="footer text-center">
            Property of Growify 2021
        </footer>
    );
}
export default Footer;
 